import {setCookie} from "./cookies";
import {getCookie} from "./cookies";

document.addEventListener('DOMContentLoaded', ()=> {
    let ageModal = document.querySelector('.js-age-modal');

    if(ageModal && document.body.classList.contains('_18') && !getCookie('age')) {
        let ageTrue = ageModal.querySelector('.js-age-true'),
            ageFalse = ageModal.querySelector('.js-age-false');

        ageModal.classList.add('_active');

        ageTrue.addEventListener('click', ()=> {
            setCookie('age', 'true', {secure: true, 'max-age': 3600});
            ageModal.classList.remove('_active');
        });

        ageFalse.addEventListener('click', ()=> {
            window.document.location = '/';
        })
    }
})